import React, { useState } from 'react';

const faqs = [
  {
    question: 'What kinds of functional support do you provide for Infor LN?',
    answer:
      'We support production, supply chain, finance, inventory, procurement, quality, service, reporting, user issues, and process improvements across Infor LN environments.',
  },
  {
    question: 'Do you help with system health checks or process reviews?',
    answer:
      'Yes. We review current configuration, workflows, reports, data quality, integrations, performance, and user adoption to identify practical improvement areas.',
  },
  {
    question: 'Can you support Infor LN implementations or rollouts?',
    answer:
      'Yes. We support discovery, blueprinting, configuration, testing, migration, training, go-live readiness, and post-go-live stabilization.',
  },
  {
    question: 'Do you offer training or documentation?',
    answer:
      'Yes. We create role-based training, process documentation, user guides, practice scenarios, and SOP support for business and technical users.',
  },
  {
    question: 'What is your approach to resolving complex LN issues?',
    answer:
      'We analyze the business process, system configuration, data flow, integrations, and user impact before recommending a clear functional or technical resolution.',
  },
  {
    question: 'Can PT KCS Tech support integrations involving Infor LN?',
    answer:
      'Yes. We help design, validate, troubleshoot, and improve integrations between Infor LN and surrounding systems such as reporting, warehouse, finance, and operational tools.',
  },
];

const LNFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  };

  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-12 bg-[#ffffff]">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-12 text-center text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">
          Frequently Asked Questions
        </h2>

        <div className="mx-auto max-w-4xl space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={faq.question}
                className="overflow-hidden rounded-xl border transition-all duration-200"
                style={{
                  backgroundColor: '#FFFFFF',
                  borderColor: isOpen ? '#4B5563' : '#E2E8F0',
                  boxShadow: isOpen ? '0 4px 20px rgba(14, 165, 164, 0.1)' : 'none',
                }}
              >
                <button
                  type="button"
                  onClick={() => toggleFaq(index)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span 
                    className="text-lg font-semibold transition-colors duration-200"
                    style={{ color: isOpen ? '#4B5563' : '#1A2634' }}
                  >
                    {faq.question}
                  </span>
                  <span 
                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xl font-bold transition-colors duration-200"
                    style={{ 
                      backgroundColor: isOpen ? '#4B5563' : '#F1F5F9',
                      color: isOpen ? '#FFFFFF' : '#64748B'
                    }}
                  >
                    {isOpen ? '-' : '+'}
                  </span>
                </button>

                <div
                  className={`transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-6 text-base leading-7 text-gray-600">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LNFAQ;
